import { Component, Input, OnInit } from '@angular/core';
import { CmsBreadcrumbsComponent, Page, PageMetaService, TranslationService, useFeatureStyles } from '@spartacus/core';
import { BreadcrumbComponent, CmsComponentData, PageLayoutService } from '@spartacus/storefront';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'cx-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: false,
})
export class CustomBreadcrumbComponent extends BreadcrumbComponent implements OnInit {
  @Input() customCrumbs?: { label: string; link: string }[];
  constructor(
    public override component: CmsComponentData<CmsBreadcrumbsComponent>,
    protected override pageMetaService: PageMetaService,
    private _translation: TranslationService,
    private pageLayoutService: PageLayoutService,
  ) {
    super(component, pageMetaService, _translation);
    useFeatureStyles('a11yTruncatedTextForResponsiveView');
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this._setCrumbs();
  }

  private _setCrumbs(): void {
    if (this.customCrumbs) {
      this.setCustomCrumbs(this.customCrumbs);
    } else {
      this.crumbs$ = combineLatest([this.pageMetaService.getMeta(), this._translation.translate('common.home')]).pipe(
        map(([meta, textHome]) => (meta?.breadcrumbs ? meta.breadcrumbs : [{ label: textHome, link: '/' }])),
      );
    }
  }

  private setCustomCrumbs(crumbs: { label: string; link: string }[]): void {
    this.crumbs$ = combineLatest([
      this._translation.translate('common.home'),
      this.pageLayoutService.page$.pipe(map((page: Page) => page.title)),
    ]).pipe(
      map(([homeLabel, pageTitle]) => {
        const homeCrumb = { label: homeLabel, link: '/' };
        const currentPage = { label: pageTitle, link: './' };
        return [homeCrumb, ...crumbs, currentPage];
      }),
    );
  }
}
